import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _HeaderPetitPrinceRoot = styled("div")<{}>(() => {
  return {
    minHeight: "780px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    [`@media ${responsiveMap.mobile}`]: {
      minHeight: "460px",
    },
  };
});
